<template>
  <div class="main">
    <div
      v-for="(item, index) of images"
      :key="index"
      class="case"
      @click="imagePreview(index)"
    >
      <div class="img">
        <van-image
          class="img"
          fit="cover"
          :src="require('@/imgs/place.png')"
        />
        <span>8</span>
      </div>
      <div class="info">
        <h1>2020年8月18日</h1>
        <p>
          后台编辑文案内容，后台编辑文案内 容，后台编辑文案内容，后台编辑文
          案内容，
        </p>
      </div>
    </div>
    <div v-if="show" class="preview">
      <van-swipe height="400" class="preview-width" @change="onChange">
        <van-swipe-item v-for="(img, index) of images" :key="index" class="preview-width">
          <van-image class="img" fit="cover" :src="img" />
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator">
            {{ current + 1 }}/{{ images.length }}
          </div>
        </template>
      </van-swipe>
      <van-icon name="close" class="close" @click="show = false" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Case',
  data() {
    return {
      current: 0,
      show: false,
      images: [
        require('@/imgs/place.png'),
        require('@/imgs/place.png')
      ]
    }
  },
  created() {
    const token = this.$store.getters.token
    const { code = '' } = this.$route.query
    if (!token) {
      if (!code) {
        location.href = this.$loginUrl(encodeURIComponent(location.href))
      }
    }
  },
  mounted() {
    this.getConfig()
  },
  methods: {
    async getConfig() {
      await this.$store.dispatch('setConfig')
    },
    onChange(index) {
      this.current = index
    },
    imagePreview(index) {
      this.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  padding: 30px;
  background: #ffffff;
  .case {
    margin-bottom: 30px;
    display: flex;
    .img {
      margin-right: 30px;
      width: 266px;
      height: 200px;
      border-radius: 12px;
      position: relative;
      overflow: hidden;
      span {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 32px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: rgba(0, 0, 0, 1);
        opacity: 0.5;
        border-radius: 12px 0px 12px 0px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
      }
    }
    .info {
      flex: 1;
      overflow: hidden;
      padding-top: 29px;
      h1 {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 800;
        color: rgba(51, 51, 51, 1);
      }
      p {
        margin-top: 23px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(102, 102, 102, 1);
      }
    }
  }
  .preview {
    position: fixed;
    top: 0;
    left: 0;
    width: 750px;
    height: 100%;
    background: rgba(51, 51, 51, 1);
    display: flex;
    padding-top: 150px;
    .close{
      position: absolute;
      top: 30px;
      right: 30px;
    }
  }
  .custom-indicator {
    // position: absolute;
    // bottom: 141px;
    // left: calc((100% - 68px) / 2);
    margin: 37px auto;
    width: 68px;
    height: 24px;
    background: rgba(0, 0, 0, 1);
    opacity: 0.3;
    border-radius: 12px;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    font-family: Arial;
    font-weight: 400;
    letter-spacing: 3px;
    color: rgba(255, 255, 255, 1);
  }
  .preview-width{
    width: 100%;
  }
}
</style>
